import styled from "styled-components";

export const StyledPage = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

export const StyledIntroPage = styled.div`
    display: flex;
    width: 100%;
    height: calc(100vh - 65px);

    @media screen and (min-width: 1920px) {
        height: calc(100vh - 80px);
    }
`;

export const StyledInnerWrapper = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 24px 40px;

    @media screen and (min-width: 1440px) {
        padding: 28px 40px;
    }

    @media screen and (min-width: 1920px) {
        padding: 28px 126px;
    }
`;

export const StyledIntroInnerWrapper = styled.div`
    width: 100%;
    height: 100%;
    margin: 32px 40px;

    @media screen and (min-width: 1920px) {
        margin: 40px 48px;
    }
`;
